import { BundledAuctionPage as BundledAuction } from 'components/auction/BundledAuctionPage';

const BundledAuctionPage = () => {
  return <BundledAuction />;
};
export default BundledAuctionPage;
